export class Modificar_ingresos{
    constructor(
        public _id: string,
        public valor: String,
        public cuenta: String,
        public tipo: String

    ){}
}